import styled from 'styled-components';
import { InlineNotification } from '@veneer/core';

export const CustomInlineNotification = styled(InlineNotification)`
  button {
    &:focus-visible {
      outline: #001cb0 solid 2px;
      outline-offset: -2px !important;
      box-shadow: none !important;
    }
  }
`;
